import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Palette, ClipboardCheck, Printer, Zap } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    Icon: Palette,
    text: '120+ actividades y proyectos listos'
  }, {
    Icon: ClipboardCheck,
    text: '60+ evaluaciones y rúbricas'
  }, {
    Icon: Printer,
    text: 'Fichas imprimibles incluidas'
  }, {
    Icon: Zap,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-6 pb-10 sm:pt-16 sm:pb-24 lg:pt-24 lg:pb-32 overflow-hidden bg-paper-main" data-id="element-99">
      {/* Subtle organic shapes for editorial feel */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] bg-paper-alt rounded-full blur-[120px] opacity-60 pointer-events-none" data-id="element-100" />
      <div className="absolute -top-24 -left-28 w-[500px] h-[500px] bg-terra-50 rounded-full blur-[100px] opacity-40 pointer-events-none" data-id="element-101" />
      <div className="absolute top-40 -right-24 w-[400px] h-[400px] bg-brand-50 rounded-full blur-[100px] opacity-40 pointer-events-none" data-id="element-102" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-104">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-terra-50 text-terra-600 font-medium text-[10px] sm:text-xs uppercase tracking-widest mb-3 sm:mb-8 border border-terra-100" data-id="element-105">
            🎨 Para profesores de Arte y Plástica
          </div>

          <h1 className="text-[26px] sm:text-5xl lg:text-7xl font-serif font-medium text-ink-800 leading-[1.1] mb-3 sm:mb-6 tracking-tight max-w-4xl mx-auto" data-id="element-106">
            Resolvé todo tu <span className="text-brand-500" data-id="element-107">año de Arte</span>{' '}
            en 5 minutos
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mb-4 sm:mb-12 mt-3 sm:mt-10 max-w-[200px] sm:max-w-xl lg:max-w-4xl mx-auto" data-id="element-108">
          <div className="relative z-10 p-1 sm:p-4" data-id="element-109">
            <img src="https://cdn.magicpatterns.com/uploads/wVFTLJC2pxnMKVd9YdvS57/ChatGPT_Image_Jun_30,_2026,_10_10_37_PM.png" alt="Sistema Profesional Arte Lista 2026" className="w-full h-auto object-contain rounded-[20px] shadow-card" data-id="element-110" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-111">
          <p className="text-sm sm:text-lg lg:text-xl text-ink-600 mb-5 sm:mb-8 leading-snug sm:leading-relaxed max-w-2xl mx-auto font-normal" data-id="element-112">
            12 tomos, 6 bonos y todo el material listo para planificar clases,
            crear proyectos y acompañar alumnos durante todo el año. Para
            Primaria y Secundaria.
          </p>

          <button onClick={scrollToPricing} className="group w-full sm:w-auto bg-brand-500 hover:bg-brand-600 text-white text-sm sm:text-lg font-medium py-3.5 sm:py-5 px-10 sm:px-12 rounded-2xl shadow-cta transition-colors duration-300 inline-flex items-center justify-center gap-3 tracking-wide" data-id="element-113">
            QUIERO ACCEDER AHORA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" data-id="element-114" />
          </button>

          <p className="mt-3 sm:mt-4 text-xs sm:text-sm text-ink-400 font-medium tracking-wide" data-id="element-115">
            🔒 Pago 100% seguro · Garantía de 7 días
          </p>
          <p className="mt-1 text-xs sm:text-sm text-ink-400 font-medium tracking-wide" data-id="element-116">
            💻 Producto 100% digital (PDF) · Entrega automática por email · Sin
            envío físico
          </p>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mt-8 sm:mt-16 max-w-4xl mx-auto" data-id="element-117">
            {badges.map((b, i) => {
            const Icon = b.Icon;
            return <div key={i} className="flex flex-col items-center gap-2 sm:gap-3 text-xs sm:text-sm font-medium text-ink-600 bg-paper-card px-3 sm:px-5 py-4 sm:py-6 rounded-[20px] shadow-soft border border-paper-border" data-id="element-118">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-brand-50 text-brand-500 flex items-center justify-center shrink-0" data-id="element-119">
                    <Icon className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={1.5} data-id="element-120" />
                  </div>
                  <span className="text-center leading-snug" data-id="element-121">{b.text}</span>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}